import { Box, Card, CardContent, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

export const AccountProfile = () => {
  const user = useSelector((store: any) => store.auth.user);

  return (
    <Card>
      <CardContent>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <AccountCircleIcon
            sx={{
              cursor: 'pointer',
              height: 80,
              width: 80,
              color: '#6366F1',
              marginBottom: 2,
            }}
          />

          <Typography gutterBottom variant='h5'>
            {user.name}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
